module.exports = __webpack_public_path__ + "static/intro-28cdd66fb69399f54dfeaafcd1c17d64.png";